import React from "react";

const NameTitle = () => {
  return (
    <h1 className="text-8xl uppercase">
      Christian <span className="text-blue-700">Escobar</span>
    </h1>
  );
};

export default NameTitle;
